export default {"src":"/_next/static/media/hero-illustration.2f8568f4.svg","height":288,"width":304,"blurWidth":0,"blurHeight":0};